export const DOCS_GET_REQUEST = 'DOCS/DOCS_GET_REQUEST';
export const DOCS_GET_SUCCESS = 'DOCS/DOCS_GET_SUCCESS';
export const DOCS_GET_FAIL = 'DOCS/DOCS_GET_FAIL';

export const DOCS_DELETE_REQUEST = 'DOCS/DOCS_DELETE_REQUEST';
export const DOCS_DELETE_SUCCESS = 'DOCS/DOCS_DELETE_SUCCESS';
export const DOCS_DELETE_FAIL = 'DOCS/DOCS_DELETE_FAIL';